<template>
  <div class="m-input-box" @click="clicked">
    <div class="mImport">
      <span class="label" v-if="label">{{label}}</span>
      <div class="showText" :class="{disable: disabled}" v-if="value">{{value}}</div>
      <input type="text" :placeholder="placeholder" disabled v-else class="dinput">
      <span class="icon icon-arrow-right unit" v-if="arrow" @click="clicked"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    arrow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit('clicked')
    }
  }
}
</script>

<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.m-input-box {
  background: $light;
  padding: 0 15px !important;
  color: $dark;
  font-size: 16px;
  border-bottom: 1px solid #f5f5f5;
}

.label {
  flex: 0 0 80px;
  font-size: 17px;
}

.mImport {
  align-items: center;
  height: 50px;
  display: flex;
}

.showText {
  border: none;
  width: 100%;
}

.unit {
  flex: 0 0 auto;
}
  .disable{
    color: #cdcdcd;
  }
  .dinput{
    display: block;
    width: 100%;
  }
</style>
